module.exports = __webpack_public_path__ + "static/media/calendar.33f64ab8.svg";